import Http from 'axios'
import {API_URL, VERSION, VERSIONED_API_URL} from '../../config/config'
import {commonInitialState} from "./common_store";
import {SET_PRINT_CONTENT} from "../mutation-type";

function initialState() {
    return {
        ...commonInitialState,
        visaRequest: {
            document: {},
            visaType: {
                regular_pricing: []
            },

            application_data: {
                address: {}
            },
            extra: {},
            traveller: {},
            someIndex: 1,
            latePenalty: 0,
            overstayPenalty: 0
        },
        loading: false,
        rejectModal: false,
        approveModal: false,
        reciprocityDurationModal: false,
        visaNumberModal: false,
        visaNumberPrintModal: false,
        cancelModal: false,
        acknowledgePenaltyModal: false,
        tippaniVerificationModel: false,
        updating: false,
        statusUpdated: false,
        paid: false,
        visa_requests: [],
        printType: 'tippani',
        voucherLoading: false,
        checkPaymentLoading: false,
        old: false,
        extended_reciprocity_visa: false,
        officeWiseUsers: [],
        assignedVisas: [],
    }
}

const getters = {
    loading: state => state.loading,
    visaRequest: state => state.visaRequest,
    rejectModal: state => state.rejectModal,
    approveModal: state => state.approveModal,
    reciprocityDurationModal: state => state.reciprocityDurationModal,
    travellerUpdating: state => state.updating,
    paid: state => state.paid,
    printType: state => state.printType,
    voucherLoading: state => state.voucherLoading,
    checkPaymentLoading: state => state.checkPaymentLoading,
    old: state => state.old,
    assignedVisas: state => state.assignedVisas
};

const actions = {
    async submitTippani({state, commit}, data) {
        await Http.put(`${API_URL}${VERSION}/visa-requests/generate-tippani/` + state.visaRequest.submission_no, data);
        commit('tippaniGenerated')
    },
    async generateVoucher({commit, state, dispatch}) {
        commit('setVoucherLoading', true);
        try {
            const {data} = await Http.put(`${API_URL}${VERSION}/visa-requests/generate-voucher/` + state.visaRequest.submission_no, {
                penalty: state.visaRequest.penalty,
            });
            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
            this.commit('Notification/showSuccess', data.message);
            commit('setVoucherLoading', false);
        } catch (e) {
            commit('setVoucherLoading', false);
            this.commit('Notification/showError', e.response.data.message);
        }
    },
    async checkPaymentStatus({commit, state, dispatch}) {
        commit('setCheckPaymentLoading', true);
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/visa-requests/check-payment-status/` + state.visaRequest.submission_no).then((res) => {
                commit('setCheckPaymentLoading', false)
                dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                resolve(true)
            }).catch((err) => {
                commit('setCheckPaymentLoading', false);
                reject(err)
            });
        }));
    },
    async checkApplicationPaymentStatus({commit, state, dispatch}, submission_no) {
        commit('setCheckPaymentLoading', true);
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/visa-requests/check-payment-status/` + submission_no).then((res) => {
                commit('setCheckPaymentLoading', false)
                resolve(true)
            }).catch((err) => {
                commit('setCheckPaymentLoading', false);
                reject(err)
            });
        }));
    },
    async checkReciprocityVisaPaymentStatus({commit, state, dispatch}) {
        commit('setCheckPaymentLoading', true);
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/visa-requests/check-reciprocity-payment-status/` + state.visaRequest.submission_no).then((res) => {
                commit('setCheckPaymentLoading', false)
                dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                resolve(true)
            }).catch((err) => {
                commit('setCheckPaymentLoading', false);
                reject(err)
            });
        }));
    },
    checkPaymentStatusOnly({commit, state, dispatch}) {
        commit('setCheckPaymentLoading', true);
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/visa-requests/check-payment-status/` + state.visaRequest.submission_no + '?only').then((res) => {
                commit('setCheckPaymentLoading', false);
                dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                this.commit('Notification/showSuccess', 'Amount has been paid');
                resolve(true)
            }).catch((err) => {
                commit('setCheckPaymentLoading', false);
                reject(err)
            });
        }));
    },
    async paymanually({commit, state, dispatch}, data) {
        commit('setCheckPaymentLoading', true);
        try {
            await Http.put(`${API_URL}${VERSION}/visa-requests/pay-manually/` + state.visaRequest.submission_no, data);
            commit('setCheckPaymentLoading', false);
            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
        } catch (e) {
            commit('setCheckPaymentLoading', false);
            throw e;

        }


    },
    getVisaRequestDetail({commit, state}, id) {
        commit('setLoading', true);
        commit('resetState');
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/visa-requests/get/' + id)
                .then(response => {
                    commit('setLoading', false)
                    commit('setVisaRequestData', response.data.data);
                    commit('setPaid', response.data.paid);
                    commit('setOld', response.data.data.old);
                    resolve(response.data)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    getVisaRequestDetailByVisa({commit, state}, id) {
        commit('setLoading', true);
        commit('resetState');
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/visa-requests/get-by-visa/' + id)
                .then(response => {
                    commit('setLoading', false)
                    commit('setVisaRequestData', response.data.data);
                    commit('setPaid', response.data.paid);
                    commit('setOld', response.data.data.old);
                    resolve(response.data)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },

    updateTraveller({commit, state}, id) {
        commit('setUpdating', true)
        return new Promise((resolve, reject) => {
            Http.put(API_URL + VERSION + '/traveller/' + state.visaRequest.traveller.id, {
                full_name: state.visaRequest.traveller.full_name,
                contact_no: state.visaRequest.traveller.contact_number,
                email: state.visaRequest.traveller.email,
                visa_visit: state.visaRequest.id
            })
                .then(response => {
                    commit('setUpdating', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setUpdating', false)
                    reject(error)
                })
        });
    }
    ,
    approveRequest({commit, state, dispatch}, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/approve/' + state.visaRequest.submission_no, data)
                .then(response => {
                    resolve(response);
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    }
    ,
    approveReciprocityVisaRequest({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/approve-reciprocity-visa/' + state.visaRequest.submission_no)
                .then(response => {
                    resolve(response);
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    cancelRequest({commit, state, dispatch}, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/cancel/' + state.visaRequest.id, data)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    acknowledgePenaltyRequest({commit, state, dispatch}, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/acknowledge-penalty/' + state.visaRequest.submission_no, data)
                .then(response => {
                    resolve(response)
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    verifyTippaniGenerated({commit, state, dispatch}, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/visa-requests/verify-tippani/` + state.visaRequest.submission_no, data).then(response => {
                this.commit('Notification/showSuccess', response.data.message);
                resolve(response)
            }).catch(error => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            }).finally(() => {
                commit('setLoading', false);
            })
        });
    },
    approveTippani({commit, state, dispatch}, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/visa-requests/approve-tippani/` + state.visaRequest.submission_no, data).then(response => {
                this.commit('Notification/showSuccess', response.data.message);
                resolve(response)
            }).catch(error => {
                this.commit('Notification/showError', error.response.data.message);
                reject(error)
            }).finally(() => {
                commit('setLoading', false);
            })
        });
    },
    async dropForwarded({commit, state, dispatch}, data) {
        commit('setLoading', true);
        try {
            const response = await Http.post(`${API_URL}${VERSION}/visa-requests/drop-forwarded/` + state.visaRequest.submission_no, data);
            commit('setLoading', false);
            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
            this.commit('Notification/showSuccess', response.data.message);
        } catch (e) {
            commit('setLoading', false);
            this.commit('Notification/showError', error.response.data.message);
        }
    },

    async marksAsCompleted({commit, state, dispatch}, data) {
        commit('setLoading', true);
        try {
            const response = await Http.post(`${API_URL}${VERSION}/visa-requests/assignment/mark-as-completed/`, data);
            commit('setLoading', false);
            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
            this.commit('Notification/showSuccess', response.data.message);
        } catch (e) {
            commit('setLoading', false);
            this.commit('Notification/showError', error.response.data.message);
        }
    },

    rejectRequest({commit, state, dispatch}, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/reject/' + state.visaRequest.submission_no, data)
                .then(response => {
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    reciprocityDurationRequest({commit, state, dispatch}, data) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/reciprocity-visa-duration/' + state.visaRequest.submission_no, data)
                .then(response => {
                    resolve(response);
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    }
    ,

    generateVisaPrintedTrack({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/generate-print-visa-number-track/' + state.visaRequest.submission_no)
                .then(response => {
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },

    printVisaNumber({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/visa-requests/print-visa/' + state.visaRequest.submission_no)
                .then(response => {
                    dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },

    async updatePreviousStay({state}, data) {
        const response = await Http.post(`${VERSIONED_API_URL}/visa-requests/update-previous-stay/` + state.visaRequest.submission_no, {
            previous_stay: state.visaRequest.new_days_stayed.countable_days_stayed
        });
        this.commit('Notification/showSuccess', response.data.message)
    }
    ,
    async verifyRequest({commit, state, dispatch}, data) {
        try {
            const previous_stay = state.visaRequest.days_stayed.countable_days_stayed;
            if (state.visaRequest.visa_type_slug === 'tourist-visa' && previous_stay === undefined || previous_stay < 0) {
                this.commit('Notification/showError', 'Cannot proceed, previous days stayed cannot be less than 0');
                return
            }
            const res = await Http.post(API_URL + VERSION + '/visa-requests/verify/' + state.visaRequest.submission_no, {
                previous_stay: state.visaRequest.days_stayed.countable_days_stayed
            });
            this.commit('Notification/showSuccess', res.data.message);

            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);

        } catch (e) {
            throw e;
        }

    }
    ,
    async applyBorderPenalty({commit, state, dispatch}, data) {
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/visa-requests/apply-border-penalty/${state.visaRequest.submission_no}`)
            this.commit('Notification/showSuccess', response.data.message)
            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
        } catch (e) {
            console.log(e)
            this.$store.commit('Notification/showError', e.response.data.message)
        }
    }
    ,
    async proceedWithoutTippani({commit, state, dispatch}, data) {
        try {
            const {data} = await Http.post(`${VERSIONED_API_URL}/visa-requests/proceed-without-tippani/` + state.visaRequest.submission_no);
            this.commit('Notification/showSuccess', data.message)
            commit('proceedWithoutTippani')
        } catch (e) {
            this.commit('Notification/error', e.response.data.message)

        }
    }
    ,
    regulateThroughTouristVisa({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            Http.post(`${VERSIONED_API_URL}/visa-requests/regulate-through-tourist-visa/` + state.visaRequest.submission_no)
                .then(response => {
                    const data = response.data
                    this.commit('Notification/showSuccess', data.message)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    this.commit('Notification/error', error.response.data.message)
                    reject(error)
                })
        });
    }
    ,
    async verifyOldVisaRequest({state, dispatch}) {
        try {
            const {data} = await Http.post(`${VERSIONED_API_URL}/visa-requests/verify-old-visa/` + state.visaRequest.submission_no)
            this.commit("Notification/showSuccess", data.message)
            dispatch('getVisaRequestDetail', state.visaRequest.submission_no);
        } catch (e) {
            this.commit('Notification/showError', e.response.data.message)
        }
    }
    ,

    async downloadVisaDetails({state, dispatch}) {
        try {
            const {data} = await Http.get(`${VERSIONED_API_URL}/visa-requests/download/` + state.visaRequest.submission_no)
            this.commit("Notification/showSuccess", 'Visa Details Downloaded Successfully')
            window.open(data.link, '_blank')
        } catch (e) {
            this.commit('Notification/showError', e.response.data.message)
        }
    }
    ,

    resetState({commit}) {
        commit('resetState')
    },
    getOfficeWiseUser({commit, state}) {
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/users/office/officeWiseUser')
                .then(response => {
                    commit('setOfficeWiseUser', response.data.data);
                    resolve(response.data)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    async forwardUser({commit, state}, data) {
        await Http.post(API_URL + VERSION + '/visa-requests/forwardUser/' + state.visaRequest.submission_no + '/' + data.user, {
            purpose: data.purpose,
            remarks: data.remarks
        })
    },
    getAssignedVisas({commit, state}) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/user/assigned-visas')
                .then(response => {
                    commit('setAssignedVisas', response.data.data);
                    resolve(response.data)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                }).finally(() => {
                commit('setLoading', false);
            })
        });
    },
}

const mutations =
    {
        setOfficeWiseUser(state, items) {
            state.officeWiseUsers = items
        },
        setAssignedVisas(state, items) {
            state.assignedVisas = items
        },
        setVisaRequestData(state, items) {
            state.visaRequest = JSON.parse(JSON.stringify(items))
        }
        ,
        setRejectModal(state, item) {
            state.rejectModal = item
        }
        ,
        setUpdating(state, item) {
            state.updating = item
        }
        ,
        setApproveModal(state, item) {
            state.approveModal = item
        }
        ,
        setReciprocityDurationModal(state, item) {
            state.reciprocityDurationModal = item
        }
        ,
        setVisaNumberModal(state, item) {
            state.visaNumberModal = item
        }
        ,
        setVisaNumberPrintModal(state, item) {
            state.visaNumberPrintModal = item
        },
        setCancelModal(state, status) {
            state.cancelModal = status
        },
        setAcknowledgePenaltyModal(state, status) {
            state.acknowledgePenaltyModal = status
        },
        setTippaniVerificationModal(state, status) {
            state.tippaniVerificationModel = status
        },
        setLoading(state, loading) {
            state.loading = loading
        }
        ,
        setPaid(state, paid) {
            state.paid = paid;
        }
        ,
        setOld(state, old) {
            state.old = old;
        }
        ,
        setPaymentInfo(state, data) {
            const visa_request = JSON.parse(JSON.stringify(state.visaRequest));
            visa_request.payment_detail = data;
            visa_request.voucher_generated = true;
            visa_request.voucher_number = data.voucher_number;
            state.visaRequest = visa_request;
        }
        ,
        setPrintType(state, printType) {
            state.printType = printType
        }
        ,
        setVoucherLoading(state, status) {
            state.voucherLoading = status;
        }
        ,
        setCheckPaymentLoading(state, status) {
            state.checkPaymentLoading = status;
        }
        ,
        tippaniGenerated(state) {
            state.visaRequest.tippani_generated = true;
        }
        ,
        proceedWithoutTippani(state) {
            const visaRequest = JSON.parse(JSON.stringify(state.visaRequest));
            visaRequest.tippani_not_required = true;
            state.visaRequest = visaRequest;
        }
        ,
        resetState(state) {
            state = initialState();
            state.visaRequest = {
                document: {},
                visaType: {
                    regular_pricing: []
                },

                application_data: {
                    address: {}
                },
                extra: {},
                traveller: {},
                someIndex: 1,
                latePenalty: 0,
                overstayPenalty: 0
            };
        }
    }
;

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
